import { useQuery } from "@tanstack/react-query";
import { api } from "../context";
import type { DocumentPDFDataResponse, PDFData } from "../interfaces";
import { millisecondsInMinute } from "date-fns";

interface UseGetPDFsProps {
  requestId: string;
  documentPDFData?: PDFData[];
}

export const useGetPDFs = ({ requestId, documentPDFData }: UseGetPDFsProps) =>
  useQuery({
    queryKey: ["request-pdf-data", requestId],
    queryFn: () =>
      api<DocumentPDFDataResponse>({
        url: `/requests/${requestId}/pdf-data`,
      }),
    enabled: !documentPDFData,
    staleTime: 5 * millisecondsInMinute,
    initialData: documentPDFData
      ? { documents: documentPDFData, treatment: documentPDFData[0] }
      : undefined,
  });
